module.exports = __webpack_public_path__ + "img/08.b2c5af95.jpg";